import { registerWebRoutings } from "rootRouting";
import { IConfig, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const url = "/menu";
export const uuid = window.location.pathname.match(
    /\/menu\/([A-Za-z0-9-]+)/
)?.[1];

const getConfig = () => {
    const config: IConfig = {
        permissions: {
            create: true,
            delete: true,
            read: true,
            update: true,
        },
        routing: [],
        url,
    };

    let routing: routingType = [];
    routing.push({
        path: `${url}/${uuid}`,
        element: <AsyncComponent path="WebMenu/pages/WebMenuIndexPage" />,
    });

    routing.push({
        path: `${url}/${uuid}/product/:id`,
        element: <AsyncComponent path="WebMenu/pages/ProductDetailsPage" />,
    });

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerWebRoutings(routing);
    }

    return config;
};

export default getConfig;
